import React from 'react'
import PoiThumbnail from '../PointOfInterest/PoiThumbnail'
import { useTranslation } from 'react-i18next'

const DisplayPois = ({ pois, isCategory = true, isCity = true }) => {
  const { t } = useTranslation()

  return (
    <div>
      {pois && pois.length > 0 ? (
        <div className="row g-4">
          {pois.map((poi) => (
            <div className="col-md-6 col-lg-4 d-flex" key={poi.id}>
              <PoiThumbnail poi={poi} isCity={isCity} isCategory={isCategory} />
            </div>
          ))}
        </div>
      ) : (
        <div className="block-wrapper">{t('NO_RESULTS')}</div>
      )}
    </div>
  )
}

export default DisplayPois
